<template>
  <div 
    :class="[
      'bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700',
      'transition-all duration-300',
      hoverable && 'hover:shadow-xl hover:scale-[1.02]',
      padding === 'sm' && 'p-4',
      padding === 'md' && 'p-6',
      padding === 'lg' && 'p-8',
      padding === 'xl' && 'p-10',
      customClass
    ]"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  hoverable?: boolean
  padding?: 'sm' | 'md' | 'lg' | 'xl'
  customClass?: string
}

withDefaults(defineProps<Props>(), {
  hoverable: false,
  padding: 'md',
  customClass: ''
})
</script>